/**
 * ETA API
 * 
 * Handles ETA calculation API calls.
 */

import api from './client';

export const etaApi = {
  /**
   * Calculate ETA between two locations
   * @param {string} startLoc - Start location (lon,lat format)
   * @param {string} endLoc - End location (lon,lat format)
   * @returns {Promise<number>} ETA in seconds
   */
  async calculate(startLoc, endLoc) {
    const response = await api.get('/api/eta', {
      params: { start_loc: startLoc, end_loc: endLoc },
    });
    return response.data.eta;
  },
};

export default etaApi;
